export default new class Subscribe {
  constructor() {
    this.subscribePanel = 'subscribe__panel';
    this.subscribePanelControl = 'js-subscribe-control';
    this.subscribePanelOpen = 'subscribe__panel-open';
    this.subscribeFormSelector = 'subscribe__form';
    this.subscribeInputNameSelector = 'subscribe__name';
    this.subscribeInputEmailSelector = 'subscribe__email';
    this.submitBtnSelector = 'subscribe__submit';
    this.inValidSelector = '_invalid';
    this.tooltipSelector = 'subscribe__tooltip';
    this.tooltipVisibleSelector = 'subscribe__tooltip_visible';
    this.preLoaderSelector = 'subscribe__preloader';
    this.subscribeIconEmail = 'subscribe__icon-email';
    this.timeShowAuto = 3000;
    this.timeoutIcon = 7000;
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.subscribeFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.sendForm(form);
      }, 0);
    });
  }

  sendForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const inputName = form.querySelector(`.${this.subscribeInputNameSelector}`);
    const name = inputName.value;

    const inputEmail = form.querySelector(`.${this.subscribeInputEmailSelector}`);
    const email = inputEmail.value;

    $.request('SubscribeData::onSubscribe', {
      data: {
        name,
        email,
      },
      loading: `.${this.preLoaderSelector}`,
      complete: ({ responseJSON }) => {
        this.showTooltip(responseJSON.message, responseJSON.status);
      },
    });
  }

  showTooltip(message, status) {
    const tooltip = $(`.${this.tooltipSelector}`);

    if (!status) {
      tooltip.addClass('tooltip__error');
    } else {
      tooltip.removeClass('tooltip__error');
    }

    tooltip.addClass(this.tooltipVisibleSelector)
      .text(message);

    this.timer = setTimeout(() => {
      this.hideTooltip();
    }, this.delay);
  }

  hideTooltip() {
    const tooltip = $(`.${this.tooltipSelector}`);
    tooltip.removeClass(this.tooltipVisibleSelector)
      .text('');
  }
}();
